import { Loader } from "@/components/common/Icons/Loader/Loader";
import { RotateIcon } from "@/components/common/Icons/RotateIcon";
import { Translate } from "@/components/common/Translate/Translate";
import { useBulkResizerRotateSettings } from "./useBulkResizerRotateSettings";

interface BulkResizerRotateSettingsProps {
    imageId: string;
}

export const BulkResizerRotateSettings = ({ imageId }: BulkResizerRotateSettingsProps) => {
    const { handleDirection, rotatingState } = useBulkResizerRotateSettings(imageId);

    return (
        <div className="pt-8 px-4">
            <div className="flex flex-col w-full">
                <div className="text-white font-semibold text-lg -mb-4">
                    <Translate keyName="rotate-image" />
                </div>
                <div className="grid grid-cols-2 gap-4 my-8">
                    <div
                        className="w-full flex flex-col text-center gap-2"
                        onClick={() => handleDirection("clock-wise")}
                        data-testid="rotate-clockwise"
                    >
                        <div>
                            <div
                                className={`dark:bg-darkSurface-200 cursor-pointer py-4 md:py-8 flex items-center justify-center border-slate-200 dark:border-darkSurface-400 border rounded-xl`}
                            >
                                {rotatingState === "clock-wise" ? (
                                    <Loader className="stroke-[var(--dark-gray)]" height={34} width={34} />
                                ) : (
                                    <RotateIcon />
                                )}
                            </div>
                        </div>
                        <div className="capitalize">
                            <Translate keyName="clock-wise" />
                        </div>
                    </div>
                    <div className="w-full flex flex-col text-center gap-2">
                        <div
                            onClick={() => handleDirection("reverse-clock-wise")}
                            data-testid="rotate-counter-clockwise"
                        >
                            <div
                                className={`dark:bg-darkSurface-200 cursor-pointer py-4 md:py-8 flex items-center justify-center border-slate-200 dark:border-darkSurface-400 border rounded-xl flipped`}
                            >
                                {rotatingState === "reverse-clock-wise" ? (
                                    <Loader className="stroke-[var(--dark-gray)]" height={34} width={34} />
                                ) : (
                                    <RotateIcon />
                                )}
                            </div>
                        </div>
                        <div className="capitalize whitespace-nowrap">
                            <Translate keyName="counter-clock-wise" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
